import { Show, SimpleShowLayout, useRecordContext, useShowContext } from "react-admin";
import { Typography } from "@mui/material";

import BackButtonToolbar from "features/BackButtonToolbar";
import BipSection from "./BipSection";
import AttachedDocumentsSection from "./AttachedDocumentsSection";
import DisciplinesSection from "./DisciplinesSection";
import DocumentGenerationSection from "./DocumentGenerationSection";
import DocumentsSection from "./DocumentsSection";
import EducationSection from "./EducationSection";
import MobilitySection from "./MobilitySection";
import PersonalDataSection from "./PersonalDataSection";

// Backend returns 200 with a null body for a missing id (no 404), so react-admin hands us an empty
// record instead of an error. Every section reads record.userInfo.*, so the guard stays here.
const Sections = () => {
  const { record, isPending } = useShowContext();

  if (isPending) return null;
  if (!record?.userInfo) return <Typography sx={{ padding: "2rem" }}>Записът не е намерен.</Typography>;

  return (
    <>
      <PersonalDataSection />
      <EducationSection />
      <MobilitySection />
      <BipSection />
      <DisciplinesSection />
      <DocumentsSection />
      <AttachedDocumentsSection id={record.id} />
    </>
  );
};
const TopToolbarActions = () => {
  const record = useRecordContext();
  return (
    <BackButtonToolbar
      additionalButton={
        <DocumentGenerationSection
          id={record?.id}
          userInfo={record?.userInfo}
        />
      }
    />
  );
};
const ShowIncomingRegularStudents = () => {
  return (
    <Show
      title="Детайли на пристигащ студент за обучение и BIP"
      actions={<TopToolbarActions />}
    >
      <SimpleShowLayout>
        <Sections />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowIncomingRegularStudents;
